export default class DataUtil {

    static getListField(data, field, emptyLabel) {
        let set = new Set();
        let hasEmpty = false
        for (const row of data) {
            const value = row[field]
            if (value == null || value === '') {
                hasEmpty = true
            } else {
                set.add(value)
            }
        }
        if (hasEmpty && emptyLabel != null) {
            set.add(emptyLabel)
        }
        return Array.from(set);
    }

    static getListChildField(data, field, childField, emptyLabel) {
        let set = new Set();
        let hasEmpty = false
        for (const row of data) {
            if (row[field] !== null && row[field] !== undefined) {
                const child = row[field][childField]
                if (child == null || child === '') {
                    hasEmpty = true
                } else {
                    set.add(child)
                }
            } else {
                hasEmpty = true
            }
        }
        if (hasEmpty && emptyLabel != null) {
            set.add(emptyLabel)
        }
        return Array.from(set);
    }
}
